<template>
	<div class="paypal-payer">
		<div class="paypal-payer__logo">
			<svg v-if="paymentMethod === 'Venmo'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 23 24" width="100%" height="100%">
				<path fill="#008CFF" d="M13.96 1.493c.471.982.772 2.173.772 3.923 0 3.197-2.274 7.885-4.116 10.868L8.643.511.5 1.28l3.73 22.166h9.3C17.602 18.117 22.62 10.53 22.62 4.69c0-1.832-.387-3.281-1.244-4.689L13.96 1.493Z" />
			</svg>
			<svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 31" width="100%" height="100%">
				<path fill="#003087" d="M7.47 29.3 8 26H1.27L5.13 1.49a.33.33 0 0 1 .32-.27h9.38c3.11 0 5.26.65 6.38 1.93a4.43 4.43 0 0 1 1 1.91 6.889 6.889 0 0 1 0 2.65v.75l.53.3c.401.201.76.476 1.06.81.466.552.768 1.224.87 1.94a8.34 8.34 0 0 1-.13 2.81 9.931 9.931 0 0 1-1.15 3.18 6.612 6.612 0 0 1-1.82 2 7.383 7.383 0 0 1-2.46 1.11c-1.004.25-2.035.372-3.07.36h-.73a2.24 2.24 0 0 0-1.43.52 2.29 2.29 0 0 0-.75 1.33v.3l-.92 5.86-.05.21a.27.27 0 0 1-.05.13.19.19 0 0 1-.1 0l-4.54-.02Z" />
				<path fill="#0070E0" d="M23.25 7.81c0 .18-.06.37-.09.55-1.24 6.35-5.47 8.55-10.88 8.55H9.53A1.33 1.33 0 0 0 8.21 18L6.8 27l-.4 2.53a.71.71 0 0 0 .7.81H12a1.17 1.17 0 0 0 1.16-1l.05-.24.92-5.84.06-.32a1.17 1.17 0 0 1 1.16-1h.73c4.72 0 8.43-1.92 9.51-7.47.45-2.33.22-4.26-1-5.63a4.642 4.642 0 0 0-1.34-1.03Z" />
				<path fill="#242E65" d="M22 7.3c-.19-.06-.384-.11-.58-.15a6.18 6.18 0 0 0-.62-.12 15.31 15.31 0 0 0-2.43-.18H11c-.177 0-.352.04-.51.12a1.15 1.15 0 0 0-.65.88l-1.56 9.9-.05.29a1.33 1.33 0 0 1 1.32-1.13h2.75c5.41 0 9.64-2.2 10.88-8.55.04-.182.07-.365.09-.55a8.515 8.515 0 0 0-1-.43L22 7.3Z" />
				<path fill="#003087" d="M9.82 7.85a1.15 1.15 0 0 1 .65-.88 1.27 1.27 0 0 1 .51-.12h7.35c.814-.005 1.626.056 2.43.18.21 0 .42.07.62.12.196.04.39.09.58.15l.28.08c.341.124.675.268 1 .43.36-2.34 0-3.94-1.28-5.39C20.68.97 18.04.15 14.81.15H5.45a1.35 1.35 0 0 0-1.33 1.13L.22 26A.81.81 0 0 0 1 27h5.8l1.46-9.23 1.56-9.92Z" />
			</svg>
		</div>
		<div class="paypal-payer__info">{{ identifier }}</div>
		<c-button
			class="paypal-payer__button"
			title="Change"
			:no-style="true"
			@click="handleChangeClick"
		>
			{{ changeButtonText }}
		</c-button>
	</div>
</template>

<script>
	import CButton from '../Button.vue';

	export default {
		name: 'CPayPalPayer',
		components: { CButton },
		props: {
			paymentMethod: { type: String, required: true },
			identifier: { type: String, default: '' },
			enabled: { type: Boolean, default: true },
			changeButtonText: { type: String, default: 'change' }
		},
		methods: {
			handleChangeClick() {
				if (this.enabled)
					this.$emit('change');
			}
		}
	};
</script>

<style lang="scss">
#{$specificity-base} {

	.paypal-payer {
		display: flex;
		align-items: center;
		gap: calc(var(--gutter) / 2);
		background: hsla(var(--background-hsl), .3);
		padding: 5px;
		background-blend-mode: difference;

		&__logo {
			display: flex;
			align-items: center;
			flex-shrink: 0;
			justify-content: center;
			width: 36px;
			height: 36px;
			background: white;
			border: 1px solid var(--checkable__border-color);
			border-radius: 50%;
			padding: 6px;
		}

		&__info {
			word-break: break-all;
		}

		&__button {
			flex-shrink: 0;
			margin-left: auto;
			color: var(--a__color) !important;
			font-family: var(--font-family);
			text-decoration: underline;
		}
	}

	.cog-form--dark-background .paypal-payer {
		background: rgba(white, .05);
	}
}
</style>